module.exports = __webpack_public_path__ + "static/media/icons8-facebook-messenger 1.9af88abf.svg";